import { Injectable } from '@angular/core';

@Injectable()
export class HeaderService {
  public isHelpButtonSet = false;
  public handler?: () => void;

  setHelpButton(handler: () => void) {
    this.isHelpButtonSet = true;
    this.handler = handler;
  }

  unsetHelpButton() {
    this.isHelpButtonSet = false;
  }
}
